

































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ModalRujukan from "@/components/modal/CardModalRujukan.vue";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import SuratRujukanRalanPreviewDialog from "@/components/pemeriksaan/konsulRujukan/SuratRujukanRalanPreviewDialog.vue";
import { storeRujukan } from "@/store/modules/rujukan";
import { storeSoap } from "@/store/modules/soap";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { getHumanDateTime } from "@/utility/DateUtils";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import SuratRujukanRalan from "@/services/SuratRujukanRalan";
import { SuratRujukanRalanItem } from "@/types";

@Component({
  components: {
    CardModalTtd,
    ModalRujukan,
    SuratRujukanRalanPreviewDialog
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardSuratRujukanRalan extends Vue {
  @Prop() readonly register!: string;
  @Prop() readonly rm!: string;
  @Prop({ type: Boolean, default: false }) readonly openTtd!: boolean;
  @Prop({ type: Boolean, default: false }) readonly openModalRujukan!: boolean;
  isReadOnly!: () => boolean;

  headers = [
    { text: "Tanggal", value: "waktu", width: "190px" },
    { text: "Faskes Tujuan", value: "tujuan", sortable: false },
    { text: "Klinik / Unit Tujuan", value: "unit_tujuan_text" },
    { text: "Diagnosa", value: "diagnosis", sortable: false },
    { text: "Dokter", value: "dokter", sortable: false },
    { text: "Aksi", value: "aksi", sortable: false, align: "end", width: "230px" }
  ];
  items: SuratRujukanRalanItem[] = [];
  loading = false;
  tokenMuat = 0;
  pageTab = "tab-soap";
  modalOpenRujukan = false;
  rujukanDiubah: SuratRujukanRalanItem | null = null;
  dialogPratinjau = false;
  pratinjau: SuratRujukanRalanItem | null = null;
  modalTtd = false;
  itemTtd: SuratRujukanRalanItem | null = null;
  signing = false;
  dialogHapus = false;
  itemHapus: SuratRujukanRalanItem | null = null;
  deleting = false;

  mounted() {
    this.segarkan();
    if (this.openModalRujukan) {
      this.openModalInput();
    }
  }

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get stateuser() {
    return userModule.user;
  }

  get canMakeRujukan() {
    if (this.readOnly) return false;
    return ["dokter", "perawat", "bidan"].includes(this.stateuser?.profesi?.toLowerCase());
  }

  get isNeedSoap() {
    return this.stateuser.unit_id > "01" && this.stateuser.unit_id < "50";
  }

  get isSoapExist() {
    return (storeSoap.detailSoap || []).length > 0;
  }

  get perluSoapDulu() {
    return this.isNeedSoap && !this.isSoapExist;
  }

  get sumberGenerate(): SuratRujukanRalanItem | null {
    const diubahId = this.rujukanDiubah ? this.rujukanDiubah.id : null;
    return this.items.find(item => item.id !== diubahId) || null;
  }

  get adaKunjunganLain() {
    return this.items.some(item => !this.isKunjunganIni(item));
  }

  @Watch("register")
  @Watch("rm")
  onPasienBerubah() {
    this.items = [];
    this.segarkan();
  }

  @Watch("modalTtd")
  onModalTtd(val: boolean) {
    if (!val && this.itemTtd) {
      this.itemTtd = null;
      appModule.NoticeDelay("Surat rujukan tersimpan sebagai draft (belum ditandatangani).");
    }
  }

  formatDate(date) {
    return getHumanDateTime(date);
  }

  diagnosaSingkat(teks: string | null) {
    const baris =
      (teks || "")
        .split(/\r?\n/)
        .map(s => s.trim())
        .find(s => s !== "") || "";
    if (!baris) return "-";
    return baris.length > 60 ? `${baris.slice(0, 57)}…` : baris;
  }

  isKunjunganIni(item: SuratRujukanRalanItem) {
    return String(item.register_id) === String(this.register);
  }

  isSigned(item: SuratRujukanRalanItem) {
    return Number(item.signed) === 1;
  }

  isDokterSurat(item: SuratRujukanRalanItem) {
    return !!item.dokter && !!this.stateuser && Number(item.dokter.id) === Number(this.stateuser.id);
  }

  bolehKelola(item: SuratRujukanRalanItem) {
    return this.canMakeRujukan && this.isKunjunganIni(item);
  }

  bisaTtd(item: SuratRujukanRalanItem) {
    return this.bolehKelola(item) && !this.isSigned(item) && this.isDokterSurat(item);
  }

  alasanTidakBisaUbah(item: SuratRujukanRalanItem) {
    if (this.isSigned(item) && !this.isDokterSurat(item)) {
      return `Sudah ditandatangani — hanya dapat diubah oleh ${(item.dokter && item.dokter.nama) ||
        "dokter penanda tangan"}`;
    }
    return "";
  }

  alasanTidakBisaHapus(item: SuratRujukanRalanItem) {
    const slot = this.isSigned(item) ? [{ ditandatangani: true, penandaTanganId: item.dokter ? item.dokter.id : null }] : [];
    return alasanTtdMengunciHapus(item.creator_user_id, slot, this.stateuser ? this.stateuser.id : null);
  }

  alasanTidakBisaTtd(item: SuratRujukanRalanItem) {
    const nama = (item.dokter && item.dokter.nama) || "dokter penanda tangan";
    if (!this.isKunjunganIni(item)) {
      return `Belum ditandatangani ${nama} (surat kunjungan lain)`;
    }
    if (this.readOnly) {
      return "Belum ditandatangani — kunjungan ini sudah terkunci";
    }
    return `Menunggu tanda tangan ${nama}`;
  }

  async muatRiwayat() {
    if (!this.rm) {
      this.items = [];
      return;
    }
    const token = ++this.tokenMuat;
    this.loading = true;
    try {
      const resp = await SuratRujukanRalan.listByPasien(this.rm);
      if (token !== this.tokenMuat) return;
      const data = resp && resp.data && resp.data.data;
      this.items = Array.isArray(data) ? data : [];
    } catch {
      if (token === this.tokenMuat) {
        this.items = [];
      }
    } finally {
      if (token === this.tokenMuat) {
        this.loading = false;
      }
    }
  }

  segarkan() {
    if (this.register) {
      storeRujukan.act_rujukan_on_reg(this.register);
    }
    return this.muatRiwayat();
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }

  openModalInput() {
    if (this.perluSoapDulu) return;
    this.rujukanDiubah = null;
    this.modalOpenRujukan = true;
  }

  editRujukan(item: SuratRujukanRalanItem) {
    if (this.alasanTidakBisaUbah(item)) return;
    this.rujukanDiubah = item;
    this.modalOpenRujukan = true;
  }

  lihat(item: SuratRujukanRalanItem) {
    this.pratinjau = item;
    this.dialogPratinjau = true;
  }

  cetak(item: SuratRujukanRalanItem) {
    SuratRujukanRalan.print(item.id);
  }

  async onSaved(payload: { data: { id?: number; signed?: number | string }; tandatangani: boolean }) {
    appModule.NoticeDelay("Berhasil Menyimpan Surat Rujukan Ralan");
    await this.segarkan();
    const data = payload && payload.data;
    if (payload && payload.tandatangani && data && data.id && Number(data.signed) !== 1) {
      const item = this.items.find(i => i.id === data.id);
      if (item) {
        this.bukaTtd(item);
      }
    }
  }

  bukaTtd(item: SuratRujukanRalanItem) {
    this.itemTtd = item;
    appModule.addMsgTtd("");
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    if (!this.itemTtd || this.signing) return;
    this.signing = true;
    try {
      const resp = await SuratRujukanRalan.sign(this.itemTtd.id, { password });
      if (resp.data.status == 1) {
        this.itemTtd = null;
        this.modalTtd = false;
        appModule.addMsgTtd("");
        appModule.NoticeDelay("Berhasil Tanda Tangan Surat Rujukan");
        this.segarkan();
      } else {
        appModule.addMsgTtd(resp.data.message || "Gagal menandatangani surat rujukan");
      }
    } catch (err) {
      appModule.addMsgTtd(err?.response?.data?.message || "Gagal menandatangani surat rujukan");
    } finally {
      this.signing = false;
    }
  }

  konfirmHapus(item: SuratRujukanRalanItem) {
    if (this.alasanTidakBisaHapus(item)) return;
    this.itemHapus = item;
    this.dialogHapus = true;
  }

  async hapus() {
    if (!this.itemHapus || this.deleting) return;
    this.deleting = true;
    try {
      const resp = await SuratRujukanRalan.destroy(this.itemHapus.id);
      if (resp && resp.status == 1) {
        appModule.NoticeDelay("Surat rujukan berhasil dihapus");
        this.dialogHapus = false;
        this.itemHapus = null;
        this.segarkan();
      }
    } finally {
      this.deleting = false;
    }
  }
}
